import React from 'react';
import PropTypes from 'prop-types';

import FormsConfigs from '../../../../store/forms/formsConfigs/formsConfigs';
import FormWrapper from '../../Forms/FormWrapper/FormWrapper';

const RegistrationStepForm = ({ form }) => {
  if (!form) return null;

  const config = FormsConfigs.getByName(form.id);

  return <FormWrapper {...form} config={config} />;
};

RegistrationStepForm.propTypes = {
  form: PropTypes.object
};

RegistrationStepForm.defaultProps = {
  form: null
};

export default RegistrationStepForm;



// WEBPACK FOOTER //
// ./src/components/containers/NewClient/RegistrationStepForm/RegistrationStepForm.js